import dataServices from "../../services/DataServices";
import { addItem, getAllItems} from '../../services/EventsDBService';
import { tickImg, crossImg } from '../../images/ImageResolver';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const styles = {
  "background-color":"#fafaff"
};

export function textWithIcon(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if (!content) {
    content = document.createElement("div");
    content.className = 'icon-cell';
    content.style.textAlign = "center";
    
    let img = document.createElement("img");
    img.className = 'icon-cell__img';
    img.width = 16;     // tweak as needed
    img.height = 16;    // tweak as needed
    img.decoding = 'async';
    img.loading = 'eager';
    content.appendChild(img);
    cell.setContent(content);
  }

  const value = String(e.data).toLowerCase();
  const imgEl = content.querySelector('.icon-cell__img');
  imgEl.src = (value === 'x') ? tickImg : crossImg;
}

export async function fetchData(tabName){
  async function fetchData(uri){
    let url = API_BASE_URL + uri;
    return dataServices.sendGetRequest(url);
  }

  async function fetchAllData(nextPageKey=null){
    let uri = `get-data?tab=${tabName}&limit=300`;
    if(nextPageKey){
      uri += `&nextPageKey=${nextPageKey}`;
    }
    const res = await fetchData(uri);
    await addItem(tabName, res.data.items);
    if(res.data.hasMore){
      return await fetchAllData(res.data.nextPageKey["content"]);
    }
    return res.data.items;
  }

  const fetchDataAsync = async () => {
    let allData = await getAllItems(tabName);
    if(allData && allData.length > 0){
      return allData;
    }else{
      await fetchAllData();
      return await getAllItems(tabName);
    }
  }
  return await fetchDataAsync()
}

export function gridConfigured(h, e) {
  const core = e.detail.api.getCoreGrid();
  const header = core.getSection("title");
  header.setRowHeight(0, h);
}

export function onCellClicked(e) {
  const grid = document.getElementById('grid');
  let pos = grid.api.getRelativePosition(e);
  if (pos.sectionType === "content") { // Prevent clicking on header section
    let rowIndex = pos.rowIndex;
    let rowDef = grid.api.getRowDefinition(rowIndex);
    
    if (rowDef) { // Prevent clicking on expanded row
      let rowId = rowDef.getRowId();
      let dv = grid.api.getDataView();
      if (!dv.isRowExpansion(rowId)) {
        dv.toggleRowExpansion(pos.rowIndex);
      }
    }
  }
}
